import Header from './components/Header';
import Hero from './components/Hero';
import { FaqSection, CommentsSection, FeaturesSection } from './components/SectionsA';
import { RankingSection, CarouselSection, CardsSection } from './components/SectionsB';
import { IndexSection, UpdatesSection, MediaSection, TopicsSection } from './components/SectionsC';
import { AppSection, ContactSection, AboutSection } from './components/MiscSections';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
        <CardsSection />
        <AppSection />
        <ContactSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
        <MediaSection />
        <AboutSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}